import type { IconSvgObject } from './types';

const ArrowUpBigIcon: IconSvgObject = [
  ["path", { d: "M11.16 3.8664L5.19211 10.2934C5.06878 10.4262 5.00024 10.6007 5.00024 10.782C5.00024 11.1785 5.32172 11.5 5.71828 11.5H9.00024V19.5C9.00024 20.0523 9.44796 20.5 10.0002 20.5H14.0002C14.5525 20.5 15.0002 20.0523 15.0002 19.5V11.5H18.2822C18.6788 11.5 19.0002 11.1785 19.0002 10.782C19.0002 10.6007 18.9317 10.4262 18.8084 10.2934L12.8405 3.8664C12.6235 3.63276 12.3191 3.5 12.0002 3.5C11.6814 3.5 11.377 3.63276 11.16 3.8664Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowUpBigIcon;
